import { render, staticRenderFns } from "./IconGlobal.vue?vue&type=template&id=277bfee5&scoped=true&"
var script = {}
import style0 from "./IconGlobal.vue?vue&type=style&index=0&id=277bfee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277bfee5",
  null
  
)

export default component.exports